import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { NotificationService, DialogService, UtilService } from '../../shared/index';
import { Router, ActivatedRoute, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { MomentService } from '../../shared/moment/moment.service';
import { EventsV4Service } from '../shared/events-v4.service';
import { EventEdit } from '../shared/event-edit.model';
import { TabsComponent, TabComponent } from '../../shared/widgets/tabs/index';
import { EventV4DashboardComponent } from '../dashboard/event-v4-dashboard.component';
import { AuthService } from '../../shared/auth/auth.service';
import { UserService } from '../../users/shared/user.service';
import { TranslationService } from '../../shared/translation/translation.service';
import {
  WlEventsV4ToolbarBroadcastService,
  WlEventsV4ToolbarEventTypeEnum,
} from '../../shared/container/toolbars/module/events-v4/broadcast/index';
import { IWlComponentCanDeactivateRoute } from '../../shared/route/index';
import { FeatureService } from '../../shared/feature/feature.service';
import { FeatureNameEnum } from '../../shared/feature/feature-name.enum';
import { Title } from '@angular/platform-browser';
import { EventV4RegistrationManagementComponent } from '../registration/event-v4-registration-management/event-v4-registration-management.component';
import { EventV4AttendeeManagementComponent } from '../attendee/event-v4-attendee-management.component';
import { EventV4RegistrationWizardComponent } from '../registration/event-v4-wizard/event-v4-registration-wizard.component';
import { EventTabsEnum } from '../shared/event-tabs.enum';
import { EventV4SettingsNotificationsComponent } from './notifications/event-v4-settings-notifications.component';

import { EventV4CustomRegFieldService } from '../shared/custom-reg-fields/event-v4-custom-reg-field.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'wl-event-v4-settings',
  templateUrl: 'event-v4-settings.component.html',
  styleUrls: ['event-v4-settings.component.css'],
    standalone: false
})
export class EventSettingsV4Component implements OnInit, AfterViewInit, OnDestroy, IWlComponentCanDeactivateRoute {
  @ViewChild('tabsContainer', { static: false }) public _tabsContainer: TabsComponent;
  @ViewChild('generalSettingsTab', { static: false }) public _generalSettingsTab: TabComponent;
  @ViewChild('dashboardTab', { static: false }) public _dashboardTab: TabComponent;
  @ViewChild('eventDashboardCtrl', { static: false }) public _eventDashboardCtrl: EventV4DashboardComponent;
  @ViewChild('eventItemsTab', { static: false }) eventItemsTab: TabComponent;
  @ViewChild('eventSettingsTab', { static: false }) eventSettingsTab: TabComponent;
  @ViewChild('registrationsTab', { static: false }) registrationsTab: TabComponent;
  @ViewChild('registrationManagement', { static: false }) registrationManagement: EventV4RegistrationManagementComponent;
  @ViewChild('attendeeManagement', { static: false }) attendeeManagement: EventV4AttendeeManagementComponent;
  @ViewChild('registrationWizardModal', { static: false }) public _registrationWizardModal: EventV4RegistrationWizardComponent;
  @ViewChild(EventV4SettingsNotificationsComponent) private _notificationsComponent: EventV4SettingsNotificationsComponent;

  public eventId: number;
  public event: EventEdit;
  public isSaving: boolean;
  public isLoading: boolean;
  public userAccessLevel: number;
  public hasEventBenefits: boolean;
  public showModal = false;
  public tenantHttpsUrl: string = '';
  public _subscriptions: Array<Subscription> = [];

  /**
   * used for usaved changes when navigating away
   */
  public _navigateAwayDeferred: { allowNavigate(): void; cancelNavigate(): void } = null;

  /**
   * the event as it is when loaded or saved. unedited. use for comparison to a changed event.
   */
  public _unchangedEvent: EventEdit;

  /**
   * construct
   * @param _route
   * @param _eventsService
   * @param _dialogService
   * @param _router
   * @param _notificationService
   * @param _eventsToolbarBroadcastService
   * @paran _featureService
   */
  public constructor(
    private _route: ActivatedRoute,
    private _eventsService: EventsV4Service,
    private _dialogService: DialogService,
    private _router: Router,
    private _notificationService: NotificationService,
    private _userService: UserService,
    private _utilService: UtilService,
    private _translationService: TranslationService,
    private _authService: AuthService,
    private _eventsToolbarBroadcastService: WlEventsV4ToolbarBroadcastService,
    private _featureService: FeatureService,
    private _momentService: MomentService,
    private _title: Title,
    private _eventV4CustomRegFieldService: EventV4CustomRegFieldService,
    private _confirmationService: ConfirmationService
  ) {
    this.eventId = 0;
    this.event = new EventEdit();
    this.isSaving = false;
    this.isLoading = false;
    this.tenantHttpsUrl = this._authService.getTenantHttpsUrl();
    this.userAccessLevel = 1;
  }

  /**
   * init the component
   */
  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('Events_Module').then((data: number) => {
      this.userAccessLevel = data;

      if (this.userAccessLevel == 0) {
        this._router.navigate(['access/denied']);
      }
    });
    this._featureService.has(FeatureNameEnum.BenefitManagement).then((data: boolean) => {
      this.hasEventBenefits = data;
    });
    //this._subscriptions.push(this._route.params
    //  .map(params => params['id'])
    this._subscriptions.push(
      this._route.paramMap.subscribe((params) => {
        this.eventId = parseInt(params.get('id'));
        this.loadEvent(this.eventId);
      })
    );
    this._subscriptions.push(
      this._eventsToolbarBroadcastService.subscribe((toolbarEvent) => {
        // only interested in registration saved
        if (toolbarEvent.type == WlEventsV4ToolbarEventTypeEnum.registrationSaved) this.handleRegistrationSaved();
      })
    );
  }

  /**
   * clean up
   */
  public ngOnDestroy(): void {
    // clean up subscriptions
    if (this._subscriptions) this._subscriptions.forEach((sub) => sub.unsubscribe());
  }

  /**
   * after view init
   */
  public ngAfterViewInit() {
    this._route.url.subscribe((urlParts) => {
      let targetTab: TabComponent = this._dashboardTab;
      if (urlParts.length == 2) {
        const urlPath = urlParts[1].path.toLowerCase();
        switch (urlPath) {
          case 'settings':
            targetTab = this._generalSettingsTab;
            break;
        }
        setTimeout(() => this._tabsContainer.select(targetTab));
      }
    });

    this._subscriptions.push(
      this._route.queryParams.subscribe((params) => {
        if (params.tab) {
          switch (params.tab) {
            case EventTabsEnum.Registrations:
              this._tabsContainer.select(this.registrationsTab);
              break;
          }
        }
      })
    );
  }

  /**
   * load the event for the given Id and save it in this.event
   * @param eventId
   */
  public loadEvent = (eventId: number): Promise<void> => {
    this.isLoading = true;
    this._unchangedEvent = null;
    return this._eventsService.getEventEdit(eventId).then(
      (data: EventEdit) => {
        if (this._utilService.isNullOrUndefined(data)) {
          this.showEventDoesntExistMessage();
        } else if (this._utilService.isNullOrLessThanOrEqualToZero(data.EventId)) {
          this.showEventDoesntExistMessage();
        } else {
          this.event = data;
          this._title.setTitle(this.event.EventName);

          // save for comparison later
          setTimeout(() => (this._unchangedEvent = JSON.parse(JSON.stringify(this.event))), 3000);
        }

        setTimeout(() => {
          this._eventDashboardCtrl.loadEventItems(false);
        });

        this.isLoading = false;
        return Promise.resolve();
      },
      (error: any) => {
        this.isLoading = false;
        return Promise.reject(error);
      }
    );
  };

  public showEventDoesntExistMessage = (): void => {
    this._translationService.get('events.settings.event-not-found-error-message').then((data: string) => {
      this._dialogService.error(data + ' (' + this.eventId.toString() + ')');
    });
  };

  public async saveEvent(bypassValidation: boolean = false): Promise<void> {
    this.isSaving = true;
    // the confirmation message is emailed; save the editor's inlined-style HTML, not the raw editor data
    await this._notificationsComponent?.flushEditor();

    //if user checked "All Day Event"
    if (this.event.IsAllDay) {
      this.event.EventDateTimes = [];
      this.event.StartTime = '';
      this.event.EndTime = '';
    }

    // if user checked "Set Hours of Each Day Separately"
    if (this.event.DisplaySeparateHours) {
      this.event.StartTime = '';
      this.event.EndTime = '';
    } else {
      this.event.EventDateTimes = [];
    }

    if (this._utilService.datesAreEqual(this.event.StartDate, this.event.EndDate)) {
      this.event.EventDateTimes = [];
    }

    let eventCustomFieldsValid = true;

    if (bypassValidation === false) {
      eventCustomFieldsValid = await this._eventV4CustomRegFieldService.validateCustomFieldDropDownValues(this.event.EventId);
    }

    if (eventCustomFieldsValid === false) {
      this.invalidCustomFieldsConfirmation();
      return Promise.resolve();
    } else {
      const eventToSave = this.prepareEventDataForApi(this.event);

      return this._eventsService.updateEvent(this.event.EventId, eventToSave).then(
        () => {
          if (!this.event.UsePublicRegistrationEndDate) {
            this.event.PublicRegistrationEndDateUtc = new Date();
            this.event.PublicRegistrationEndDateUtc.setUTCHours(24, 0, 0, 0);
          }
          // save for comparison later
          this._unchangedEvent = JSON.parse(JSON.stringify(this.event));
          this._notificationService.success('Event Saved');

          this.event = { ...this.event };

          this.isSaving = false;
        },
        (error: any) => {
          this.isSaving = false;
        }
      );
    }
  }

  private invalidCustomFieldsConfirmation() {
    this._confirmationService.confirm({
      message: this._translationService.getInstant('events.settings.general.component.invalid-custom-field-warning', {
        action: this._translationService.getInstant('common.save'),
      }),
      key: 'invalidCustomFieldsCD',
      reject: () => {
        this.isSaving = false;
        this._confirmationService.close();
      },
    });
  }

  private prepareEventDataForApi(event: EventEdit): EventEdit {
    return {
      ...event,
      StartDate: this._utilService.dateToUtcMidnight(event.StartDate),
      EndDate: this._utilService.dateToUtcMidnight(event.EndDate),
      EventDateTimes: event.EventDateTimes.map((dateTime) => ({
        ...dateTime,
        EventDate: this._utilService.dateToUtcMidnight(dateTime.EventDate),
      })),
    };
  }

  /**
   * return false to cancel route navigation.
   * if a promise<boolean> or observable<boolean> is returned, then they'll be awaited.
   *
   * @param routeSnapshot
   * @param stateSnapshot
   */
  canNavigateAway(
    routeSnapshot: ActivatedRouteSnapshot,
    stateSnapshot: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // can't save, don't need to ask
    if (this.userAccessLevel < 2) return true;

    // oh, it's not even dirty
    if (!this.isEventDirty()) return true;

    return new Promise<boolean>((resolveFn, rejectFn) => {
      this._navigateAwayDeferred = {
        allowNavigate: () => resolveFn(true),
        cancelNavigate: () => resolveFn(false),
      };

      this.showModal = true;
    });
  }

  /**
   * check if the event is changed.
   * Very expensive. Do not use often.
   */
  public isEventDirty(): boolean {
    if (this.isLoading) return false;

    if (this.event && (!this.event.Version || this.event.Version < 3)) return false;

    // compare literals
    let dirty: boolean = this.compareLiteralProperties(this._unchangedEvent, this.event);

    return dirty;
  }

  /**
   * compare litteral properties of 2 objects. won't compare arrays or other objects in the object.
   * Does compare Date objects... after all, this is an event manager.
   * @param a
   * @param b
   */
  public compareLiteralProperties(a: Object, b: Object): boolean {
    if (a === b || (a == null && b == null)) return true;

    if ((a == null && b != null) || (a != null && b == null)) return false;

    let dirty: boolean = false;

    // makes intellisense happy when using [key] subscript on strongly typed objects
    let aAny: any = <any>a;
    let bAny: any = <any>b;

    const dateDiffThreshhold: number = 1000;

    for (let key of Object.keys(a))
      try {
        let oftype: string = typeof aAny[key];

        // first check for any dates... because dates come over as strings?
        if (aAny[key] instanceof Date || bAny[key] instanceof Date)
          dirty =
            Math.abs(
              this._momentService
                .getMomentByObject(aAny[key])
                .startOf('day')
                .diff(this._momentService.getMomentByObject(bAny[key]).startOf('day'))
            ) > dateDiffThreshhold;
        // then only compare litteral properties
        else if (oftype == 'boolean' || oftype == 'number') dirty = bAny[key] != aAny[key];
        // strings are always special
        else if (oftype == 'string' && (!!aAny[key] || !!bAny[key]))
          dirty = (!aAny[key] && !!bAny[key]) || (!!aAny[key] && !bAny[key]) || aAny[key] != bAny[key];

        if (dirty) break;
      } catch (e) {}

    return dirty;
  }

  /**
   * when navigating away and the event is unsaved, they clicked "save" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalSaveClick(): void {
    this.saveEvent()
      .then(() => (this.showModal = false))
      .then(() => this._navigateAwayDeferred.allowNavigate());
  }

  /**
   * when navigating away and the event is unsaved, they clicked "cancel" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalCancelClick(): void {
    this.showModal = false;
    this._navigateAwayDeferred.cancelNavigate();
  }

  /**
   * when navigating away and the event is unsaved, they clicked "no" on the modal asking if they want to save changes
   */
  public handleUnsavedChangesModalNoClick(): void {
    this.showModal = false;
    this._navigateAwayDeferred.allowNavigate();
  }

  /**
   * triggered when registration is saved
   */
  public handleRegistrationSaved() {
    this.registrationManagement.getRegistrations();
    this.attendeeManagement.getAttendees();
    this._eventDashboardCtrl.refresh();
  }

  /**
   * handles event item list changes from the event items control
   */
  public eventItemsListChanged(): void {
    this._eventDashboardCtrl.refresh();
  }

  /**
   * triggered by clicking new registration button
   */
  public handleNewRegistrationClick() {
    // request a new registration window
    // this._eventsToolbarBroadcastService.broadcast({ type: WlEventsV4ToolbarEventTypeEnum.newRegistration, data: this.eventId });
    this._registrationWizardModal.openEventRegistrationForEventId(this.eventId);
  }

  /**
   * Handles delete button click
   */
  public deleteClick(): void {
    this._eventsToolbarBroadcastService.broadcast({ type: WlEventsV4ToolbarEventTypeEnum.deleteEvent, data: this.eventId });
  }

  /**
   * handles browser back and forward button navigation
   */
  @HostListener('window:beforeunload', ['$event']) public handleWindowBeforeUnload($event: any): boolean {
    return !this.isEventDirty();
  }
}
